import { TankersEvent } from './TankersEvent';

export class ErrorMsg {
    constructor(error: boolean, message: string, isDeleted: boolean, notValidatedEvent: TankersEvent | null) {
        this.error = error;
        this.message = message;
        this.isDeleted = isDeleted;
        this.notValidatedEvent = notValidatedEvent;
    }
    error: boolean;
    message: string;
    isDeleted: boolean;
    notValidatedEvent: TankersEvent | null;
}
